<template>
  <qx-card title="列表">
    <LogRightDialog
      ref="logRightDialog"
      busiCode="imp100041"
    />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>发布
        </el-button>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section  slot-scope="scope">
              <section v-if="scope.column.property === 'customerCode'" @click="toDetail(scope.row)">
                <span class="primary cur">{{scope.row[scope.column.property]}}</span>
              </section>
              <section v-else-if="scope.column.property === 'lineNumber'" @click="toLine(scope.row)">
                <span class="primary cur">{{scope.row[scope.column.property]}}</span>
              </section>
              <section v-else>{{scope.row[scope.column.property]}}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="160">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="cancelBlack(scope.row.customerId)">解除</span>
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import {
  blackList,
} from 'api/archives';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'driverName',
            label: '司机姓名',
          },
          {
            prop: 'driverPhone',
            label: '司机电话',
          },
          {
            prop: 'identification',
            label: '身份证号',
          },
          {
            prop: 'belongTenantName',
            label: '归属车队',
          },
          {
            prop: 'createUserName',
            label: '创建人',
          },
          {
            prop: 'createDate',
            label: '发布时间',
          },
          {
            prop: 'reason',
            label: '原因',
          },
          {
            prop: '1',
            label: '名单类型',
          },
          {
            prop: '2',
            label: '状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: blackList,
    async cancelBlack (id) {
      const confirmRes = await this.$confirm('解除后该司机能够正常接业务，确定解除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
      if (confirmRes === 'confirm') {
        this.$message({
          type: 'success',
          message: '解除成功',
        });
        this.getData();
      }
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + '黑名单',
        url: `/manage/archives/blackList/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
